import script from "./BrandTicketmaster.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandTicketmaster.vue?vue&type=script&setup=true&lang=js"

import "./BrandTicketmaster.vue?vue&type=style&index=0&id=64ba50bf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_webpack@5.111.1_postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64ba50bf"]])

export default __exports__